import { AttackStatusBadge } from '../badge'
import React from 'react'
import { AttackStatus } from '../attack-status'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { theme as deprecatedTheme } from '../../styled'
import { FormattedMessage } from 'react-intl'
import { readOnlyGridCss } from '../../legacy-design-system/text'

const validateStatus = (status: string | undefined) =>
  typeof status === 'string' &&
  Object.keys(AttackStatus).find((v) => v === status)

interface ApplicationAttackStatusProps {
  readonly hasAProtectedServer: boolean
  readonly attackStatus: AttackStatus
  readonly attackTotal?: number
  readonly small?: boolean
}

export function ApplicationAttackStatus({
  hasAProtectedServer,
  attackStatus,
  attackTotal,
  small
}: ApplicationAttackStatusProps) {
  return hasAProtectedServer ? (
    validateStatus(attackStatus) ? (
      <div
        className={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        `}
      >
        {!!attackTotal && <ActiveAttacksMessage total={attackTotal} />}
        <AttackStatusBadge status={attackStatus} />
      </div>
    ) : (
      <NoActiveAttacksMessage small={small} />
    )
  ) : (
    <AppNotProtectedMessage small={small} />
  )
}

function ActiveAttacksMessage({ total }: { readonly total: number }) {
  return (
    <span
      className={css`
        font-family: ${deprecatedTheme.fontFamilies.secondary};
        color: ${theme.color.turquoise70};
        font-size: 12px;
        padding-bottom: 5px;
      `}
    >
      <FormattedMessage id="plural_nActiveAttacks" values={{ count: total }} />
    </span>
  )
}

function NoActiveAttacksMessage({
  small = false
}: {
  readonly small?: boolean
}) {
  return (
    <span
      className={css`
        font-family: ${deprecatedTheme.fontFamilies.secondary};
        font-size: ${small ? '10px' : '14px'};
        color: ${theme.color.neutral50};
        font-style: italic;
      `}
    >
      <FormattedMessage id="detail_noActiveAttacks" />
    </span>
  )
}

function AppNotProtectedMessage({
  small = false
}: {
  readonly small?: boolean
}) {
  return (
    <FormattedMessage id="detail_protectIsOff">
      {(text) => (
        <span
          className={
            small
              ? cx(
                  readOnlyGridCss,
                  css`
                    font-size: 10px;
                  `
                )
              : readOnlyGridCss
          }
          children={text}
        />
      )}
    </FormattedMessage>
  )
}
